<script lang="ts">
	import { type CmsData, type CmsImageData, extractCmsImage, type ImageFormat } from '$lib/cms-types';

	export let cmsData: CmsData;
	export let format: ImageFormat = undefined;
	export let cssClass: string;

	let data: CmsImageData;

	$: {
		data = extractCmsImage(cmsData, format);
	}
</script>

<img alt={data.alt} width={data.width} height={data.height} src={data.url} class={cssClass} />
